<template>
	<span :style="{ minWidth: `${sizePX}px` }" class="relative">
		<n-avatar
			v-if="patient.picture"
			:class="{ 'badge-mask': isRegistered, 'text-scaled': resizeInitials }"
			class="flex!"
			round
			:size="sizePX"
			:src="patient.picture[100]"
			:img-props="{ alt: `${fullname} avatar` }"
		/>
		<n-avatar
			v-else
			:class="{ 'badge-mask': isRegistered, 'text-scaled': resizeInitials }"
			round
			:size="sizePX"
			class="flex!"
		>
			{{ initials }}
		</n-avatar>
		<div
			v-if="patient.is_registered"
			class="absolute right-0.5 -bottom-px flex size-3.5 flex-col items-center justify-center rounded-full bg-[#4921E8] ring-1 ring-white"
		>
			<Icon name="carbon:link" :size="8" class="text-white" />
		</div>
	</span>
</template>

<script setup lang="ts">
import type { Patient } from "@/types/patient"
import { NAvatar } from "naive-ui"
import { computed } from "vue"
import Icon from "@/components/common/Icon.vue"

const { patient, size, resizeInitials } = defineProps<{
	patient: Patient
	size?: "small" | "medium" | "large" | number
	resizeInitials?: boolean
}>()

const sizePX = computed(() => (size === "large" ? 48 : size === "medium" ? 40 : size === "small" ? 32 : size))
const fullname = computed(() => `${patient.name} ${patient.surname}`)
const isRegistered = computed(() => patient.is_registered)
const initials = computed(() =>
	fullname.value
		.split(" ")
		.map(o => o[0])
		.join("")
		.substring(0, 3)
		.toUpperCase()
)
</script>

<style lang="scss" scoped>
.badge-mask {
	/* WebKit-based browsers (Chrome, Safari, etc.) */
	-webkit-mask-image: radial-gradient(circle 1px at calc(100% - 9px) calc(100% - 6px), transparent 9px, #000 0);
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: 100% 100%;

	/* Standard syntax (for Firefox and future-proofing) */
	mask-image: radial-gradient(circle 1px at calc(100% - 9px) calc(100% - 6px), transparent 9px, #000 0);
	mask-repeat: no-repeat;
	mask-size: 100% 100%;
}
</style>
